import { useEffect, useState, type ReactElement } from 'react';
import { ModalReasonFooter } from './ModalReasonFooter';
import { VapModal } from './VapModal';

interface Props {
  title: string;
  description: string;
  isOpen: boolean;
  isSubmitting: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
  confirmLabel?: string;
}

export function ReasonModal({
  title,
  description,
  isOpen,
  isSubmitting,
  onCancel,
  onConfirm,
  confirmLabel = 'Confirm'
}: Props): ReactElement | null {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (!isOpen) setReason('');
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <VapModal id="vap-reason-modal" title={title} onClose={onCancel}>
      <div style={{ display: 'flex', flexDirection: 'column', padding: '0.5rem 0.25rem' }}>
        <p style={{ margin: '0 0 1.25rem 0', color: '#444' }}>{description}</p>

        <ModalReasonFooter
          reason={reason}
          onReasonChange={setReason}
          onCancel={onCancel}
          onConfirm={() => onConfirm(reason.trim())}
          isSubmitting={isSubmitting}
          confirmLabel={confirmLabel}
        />
      </div>
    </VapModal>
  );
}
